import React from "react";
import ReactDOM from "react-dom";
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { routerReducer } from 'react-router-redux';
import { Provider } from 'react-redux';
import { I18nextProvider } from "react-i18next";
import thunk from 'redux-thunk';
import App from "./App.jsx";
import * as cardReducer from './reducers/cards_reducer.jsx';
import * as operationsReducer from './reducers/operations_reducer.jsx';
import * as devicesReducer from './reducers/devices_reducer.jsx';
import * as tanksReducer from './reducers/tanks_reducer.jsx';
import * as appReducer from './reducers/app_reducer.js';
import * as serviceWorker from './serviceWorker';
import i18n from './utils/localizations.jsx';

const reducers = combineReducers({
    routing: routerReducer,
    cards: cardReducer.reducer,
    operations: operationsReducer.reducer,
    devices: devicesReducer.reducer,
    tanks: tanksReducer.reducer,
    app: appReducer.reducer
});

function configureStore(initialState) {
    return createStore(reducers, initialState, applyMiddleware(thunk));
}

const store = configureStore();


ReactDOM.render(
    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
                <App />
        </I18nextProvider>
    </Provider>,
    document.getElementById('app')
)

serviceWorker.unregister();